import React from 'react'
import { Link } from 'react-router-dom'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import CardUI from '../../../widgets/layout/CardUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF'
import ComplianceUpdateModalSF from './ComplianceUpdateModalSF'
import SelectUI from '../../../widgets/input/SelectUI';
import CreateComplianceModalSF from './CreateComplianceModalSF'
import CovenantComplianceUpdateModalSF from './CovenantComplianceUpdateModalSF'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import WaiveCompliancePenalChargeModalSF from './WaiveCompliancePenalChargeModalSF'

const CompliancePageUI = ({
  context, loan, errorList, compliance, complianceCodeList, yearMonth,
  onRefreshClick, onPreviousClick, onNextClick,
  penalChargeUpdateMode, onPenalChargeUpdateClick, onPenalChargeUpdateCancel,
  complianceUpdateMode, onComplianceUpdateClick, onComplianceUpdateCancel, selectedLoanCompliance,
  onCreateEmailClick, emailCreated, selectedFilter, onFilterChange,
  onCreateComplianceClick, onCancelCreateCompliance, createMode, onCovenantUpdateClick,
  covenantUpdateMode, onCovenantUpdateCancel, onCreateCurrentCompliancesClick, createCurrentCompliancesSubmitted,
  defaultInterest, onUpdateNumberOfNoticesClick, updateNumberOfNoticesSubmitted
}) => {
  const filterOptions = [
    { value: 'all', label: 'All' },
    { value: 'not_complied', label: 'Not Complied' },
    { value: 'complied', label: 'Complied' },
  ];
  const allClausesComplied =
    Array.isArray(complianceCodeList) && complianceCodeList.length > 0 &&
    complianceCodeList.every(complianceCode =>
      Array.isArray(complianceCode.clauseList) && complianceCode.clauseList.length > 0 &&
      complianceCode.clauseList.every(clause => clause.status === 'complied')
    );
  const allowedLegalLanguageCodes = new Set([
    "security_condition_compliance_of_sch_vii",
    "non_furnishing_of_share_certificate",
    "non_furnishing_of_sh_4",
    "non_filing_of_chg_1",
    "non_furnishing_of_pledge_sequence_number",
    "non_furnishing_of_extension_letter_of_ppa",
    "non_furnishing_of_tax_invoices_bearing_hypothecation_in_favour_of_lender",
    "non_furnishing_of_insurance_policy_endorsed_in_favour_of_lender",
    "non_furnishing_of_net_metering_certificate",
    "non_furnishing_of_registrations_certificate",
    "clause_4_2_g",
    "clause_5",
    "clause_4_3",
    "clause_4_1",
  ]);

  const hasNotCompliedClauses = complianceCodeList && complianceCodeList.some(complianceCode =>
    complianceCode.clauseList && complianceCode.clauseList.some(clause =>
      allowedLegalLanguageCodes.has(clause.legalLanguageCode) && clause.status === 'not_complied'
    )
  );

  const currentDate = new Date();
  const yearMonthStr = (!yearMonth || yearMonth.year === undefined || yearMonth.month === undefined)
    ? `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}`
    : `${yearMonth.year}-${yearMonth.month.toString().padStart(2, '0')}`;

  return (
    <SuperUserLoanPageSF context={context} className='pg_su_feas'
      backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
      headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
      centered={!loan || !errorList} loan={loan} page='compliance'
      dimension='w768'
    >
      {
        (!loan || !errorList) &&
        <SpinnerComponentUI />
      }
      {
        errorList && errorList.length > 0 &&
        <GenericErrorUI error={errorList[0]} />
      }
      {
        loan &&
        <div>
          <LRTableActionsUI location='top'
            left={
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                {/* <IconButtonUI icon='icon-plus' onClick={onCreateComplianceClick} /> */}
                <span className='g_m_left_100 g_large'><b>
                  Compliances,&nbsp;
                  {(yearMonth && yearMonth.monthName && yearMonth.year)
                    ? `${yearMonth.monthName} ${yearMonth.year}`
                    : 'Loading...'}
                </b>
                </span>
              </span>
            }
            right={
              <span className='g_text_right'>
                <div className='g_flex_h g_flex_right'>
                  <span className='g_m_left_100' />
                  <Link to='#' onClick={onPreviousClick}>Previous</Link>
                  <span className='g_m_left_100' />
                  <Link to='#' onClick={onNextClick}>Next</Link>
                </div>
                <div className='g_m_top_20'>

                  <SelectUI
                    selectedKey={selectedFilter}
                    optionList={filterOptions}
                    onChange={onFilterChange}
                    placeholder='Select Filter'
                  />
                  <div className='g_m_top_20'>
                    <span className='g_flex_h'>
                      {compliance && compliance.accountId && (
                        <Link to={`/su/accounts/${compliance.accountId}/messageApprovals`}>
                          Message Approvals
                        </Link>
                      )}
                      <Link to={`/su/compliance`}>Compliance Report</Link>
                    </span>
                  </div>
                  <span
                    className={`g_flex_v g_m_top_20 ${(loan.complianceNoticeSent === 0 || loan.complianceNoticeSent === undefined || loan.complianceNoticeSent === null)
                      ? 'g_muted'
                      : loan.complianceNoticeSent === 1
                        ? 'g_alert'
                        : loan.complianceNoticeSent === 2
                          ? 'g_warn'
                          : loan.complianceNoticeSent >= 3
                            ? 'g_error'
                            : ''
                      }`}
                  >
                    Number of Notices Created: {loan.complianceNoticeSent || 0}
                  </span>
                  {
                    allClausesComplied && (
                      <ButtonTinyWithSpinnerUI
                        label='Update Number of Notices Created to 0'
                        onClick={onUpdateNumberOfNoticesClick}
                        busy={updateNumberOfNoticesSubmitted}
                      />
                    )
                  }
                  {/* <span className='g_m_left_100' />
                  <Link to='#' onClick={onAddChargesClick}>Add Out-of-pocket Expenses</Link> */}
                </div>
              </span>
            }
          />
          <div className='g_flex_h'>
            {complianceCodeList && (
              <div className='g_flex_h g_m_bottom_50'>
                {complianceCodeList.reduce((total, item) => total + item.clauseList.length, 0) === 1
                  ? '1 compliance shown'
                  : `${complianceCodeList.reduce((total, item) => total + item.clauseList.length, 0)} compliances shown`}
              </div>
            )}
          </div>
          <div className='g_flex_h'>
            <div className='g_flex_v'>
              {yearMonth && yearMonth.current && (
                <span className='g_m_bottom_50 '>
                  Total Penal Charge: ₹ {defaultInterest.defaultInterestF5}
                  <span className='icon icon-pencil g_m_left_50' onClick={onPenalChargeUpdateClick} />
                </span>
              )}
              {
                !hasNotCompliedClauses && defaultInterest && defaultInterest.formula && (
                  <span className='g_muted g_small'>
                    Default Charge Formula: {defaultInterest.formula}
                  </span>
                )
              }

              {hasNotCompliedClauses && (
                <>
                  {defaultInterest.formula === 'Penal charge waived' ? (
                    <span className="g_muted g_small">Penal charge has been waived</span>
                  ) : (
                    <>
                      <span>
                        Current Penal Charge: ₹{" "}
                        {(() => {
                          const clauseList = complianceCodeList
                            ? complianceCodeList.flatMap(item => item.clauseList)
                            : [];

                          const filteredClauses = clauseList.filter(clause =>
                            allowedLegalLanguageCodes.has(clause.legalLanguageCode)
                          );

                          const uniquePenalCharges = [...new Set(filteredClauses.map(clause => clause.penalCharge))];

                          return uniquePenalCharges.length > 0 ? uniquePenalCharges[0] : "N/A";
                        })()}
                      </span>

                      <span className="g_muted g_small">
                        Penal Charge Formula:
                        {(() => {
                          const clauseList = complianceCodeList
                            ? complianceCodeList.flatMap(item => item.clauseList)
                            : [];
                          const uniquePenalChargeFormulas = [...new Set(clauseList.map(clause => clause.penalChargeFormula).filter(Boolean))];
                          return uniquePenalChargeFormulas.map((formula, index) => (
                            <span key={index} style={{ display: 'block', wordWrap: 'break-word' }}> {formula}</span>
                          ));
                        })()}
                      </span>
                    </>
                  )}
                </>
              )}

            </div>
            <div className='g_flex_v g_text_right' style={{ marginLeft: 'auto' }}>
              {
                yearMonth && yearMonth.current &&
                <span className='g_flex_v'>
                  <Link to='#' onClick={onCreateEmailClick}>Create email message approval</Link>
                  <span className='g_m_top_10' />
                  <SpinnerUI show={emailCreated} />
                </span>
              }
              {
                yearMonth && yearMonth.current &&
                <ButtonTinyWithSpinnerUI
                  label='Check Compliances'
                  onClick={onCreateCurrentCompliancesClick}
                  busy={createCurrentCompliancesSubmitted}
                />
              }
            </div>
          </div>
          {
            !compliance &&
            <EmptyListUI
              context={context}
              createDisabledMessageLabel={
                loan.status === 'disbursed'
                  ? 'No Non-Compliances'
                  : loan.status === 'closed'
                    ? 'Loan is closed'
                    : ['requested', 'term_sheet', 'sanctioned'].includes(loan.status)
                      ? 'Loan is not disbursed '
                      : ''
              }
            />
          }

          {
            compliance && complianceCodeList &&
            <ComplianceUI complianceCodeList={complianceCodeList} onComplianceUpdateClick={onComplianceUpdateClick}
              onCovenantUpdateClick={onCovenantUpdateClick} covenantUpdateMode={covenantUpdateMode} />
          }
        </div>
      }

      {
        loan &&
        <WaiveCompliancePenalChargeModalSF context={context} loan={loan} onRefreshClick={onRefreshClick} yearMonth={yearMonthStr}
          updateMode={penalChargeUpdateMode} onCancelClick={onPenalChargeUpdateCancel} />
      }
      <ComplianceUpdateModalSF context={context} loan={loan} selectedLoanCompliance={selectedLoanCompliance}
        updateMode={complianceUpdateMode} onCancelClick={onComplianceUpdateCancel} onRefreshClick={onRefreshClick} />
      <CovenantComplianceUpdateModalSF context={context} loan={loan} selectedLoanCompliance={selectedLoanCompliance}
        updateMode={covenantUpdateMode} onCancelClick={onCovenantUpdateCancel} onRefreshClick={onRefreshClick}
      />

      <CreateComplianceModalSF
        context={context}
        loan={loan}
        createMode={createMode}
        onCancelClick={onCancelCreateCompliance}
        onRefreshClick={onRefreshClick}
      />

    </SuperUserLoanPageSF>
  );
};

const ComplianceUI = ({ onComplianceUpdateClick, complianceCodeList, onCovenantUpdateClick, covenantUpdateMode }) =>
  <CardUI className='g_m_top_100'>
    <table>
      <tbody>
        {
          complianceCodeList.map((complianceCode, i) =>
            <tr key={i}>
              <td>
                <div>
                  <span>
                    <b>{complianceCode.complianceTitle}</b>
                  </span>
                  <br></br>
                  {
                    complianceCode.clauseList.map((clause, j) => {
                      let DPD = null;

                      // Determine DPD based on legalLanguageCode
                      if ([
                        'share_certificate',
                        'share_transfer_form',
                        'form_chg_1',
                        'pledge_sequence_number',
                        'extension_letter',
                        'tax_invoices',
                        'transit_insurance',
                        'net_metering_certificate',
                        'registration_certificates',
                        'non_compliance_of_financial_covenants',
                        'non_compliance_of_reps_and_warranties',
                        'non_compliance_of_negative_covenants',
                        'non_compliance_of_information_covenants',

                      ].includes(clause.legalLanguageCode)) {
                        DPD = clause.daysPastDue;
                      } else if ([
                        'dsra_dip_in_case_of_emi_default',
                        'dsra_dip_in_case_of_levying_of_penal_charges',
                        'emi_default'
                      ].includes(clause.legalLanguageCode)) {
                        DPD = clause.financialDaysPastDue;
                      }

                      return (
                        <div className='g_flex_h' key={j}>
                          <div>
                            <div className='g_flex_h'>
                              <div className='g_flex_v'>
                                <span><b>{j + 1}. {clause.clause} {clause.itemName}</b></span><br />
                                {![
                                  'non_compliance_of_sch_vii_and_non_compliance_of_escrow_wrt_routing_of_receivables',
                                ].includes(complianceCode.complianceCode) &&
                                  DPD !== null && (
                                    <span className='g_muted g_small'><b>DPD: {DPD} days</b></span>
                                  )}
                              </div>
                              {/* edit only for below */}
                              {
                                ['non_compliance_of_financial_covenants', 'non_compliance_of_negative_covenants',
                                  'non_compliance_of_information_covenants', 'non_compliance_of_reps_and_warranties'].includes(complianceCode.complianceCode) &&
                                <span
                                  className='icon icon-pencil g_m_left_10'
                                  data-id={clause.legalLanguageCode}
                                  onClick={onCovenantUpdateClick}
                                  style={{ cursor: 'pointer' }}
                                  title="Edit Covenant"
                                />

                              }
                            </div>
                            <span dangerouslySetInnerHTML={{ __html: clause.nonComplianceText }}></span><br />
                            <span><b>Remedial action: </b><span dangerouslySetInnerHTML={{ __html: clause.remedialActionText }}></span></span><br />
                            <br></br>
                          </div>
                          <div className='g_flex_v g_m_left_100' style={{ justifyContent: 'flex-end' }}>
                            <div className='g_flex_h g_m_left_100'>
                              <div className='g_flex_v'>
                                <BadgeUI label={clause.status} />
                                {
                                  clause.cureDate &&
                                  <span className='g_small g_info'>Cure Date: <br />{clause.cureDate}</span>
                                }
                              </div>
                              <span
                                className='icon icon-pencil g_m_left_50 g_muted'
                                onClick={(e) => onComplianceUpdateClick(e, clause.loanComplianceId, clause.legalLanguageCode)}
                                title="Update Status"
                                style={{ cursor: 'pointer' }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </td>
            </tr>
          )
        }
      </tbody>
    </table>
  </CardUI>

export default CompliancePageUI